import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import validate from '../ValidationHelpers'
const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140
  }
})

export default withStyles(styles)(
  class RightFormComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      handleChange: PropTypes.func.isRequired,
      companyName: PropTypes.string,
      adresse: PropTypes.string,
      cp: PropTypes.string,
      city: PropTypes.string,
      phone: PropTypes.string
    }
    static defaultProps = {
      companyName: '',
      adresse: '',
      cp: '',
      city: '',
      phone: ''
    }
    state = {
      errors: {}
    }
    handleChange = name => event => {
      let errorMessage = validate(name, event.target.value).errorMessage
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: errorMessage
        }
      })
      // if (name === 'country') {
      //   changes.currency = countries[event.target.value].currency
      // }
      this.props.handleChange(name, event.target.value)
    }

    render() {
      const { classes, companyName, adresse, cp, city, phone } = this.props
      const { errors } = this.state
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="space-between"
          spacing={24}>
          <Grid item xs={11} sm={10} md={10}>
            <Typography variant="title">Société</Typography>
          </Grid>
          <Grid item xs={10} sm={9} md={9}>
            <Divider light />
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.companyName}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="company-input">Nom de la Société</InputLabel>
              <Input
                id="company-input"
                value={companyName}
                onChange={this.handleChange('companyName')}
              />
              <FormHelperText>
                {errors.companyName
                  ? errors.companyName
                  : `Nom de la société ou raison sociale`}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.adresse}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="adresse-input">Adresse</InputLabel>
              <Input
                id="adresse-input"
                value={adresse}
                onChange={this.handleChange('adresse')}
              />
              <FormHelperText>
                {errors.adresse ? errors.adresse : null}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.cp}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="cp-input">Code Postal</InputLabel>
              <Input
                id="cp-input"
                value={cp}
                onChange={this.handleChange('cp')}
              />
              <FormHelperText>{errors.cp ? errors.cp : null}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.city}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="city-input">Ville</InputLabel>
              <Input
                id="city-input"
                value={city}
                onChange={this.handleChange('city')}
              />
              <FormHelperText>
                {errors.city ? errors.city : null}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} sm={8} md={8}>
            <FormControl
              error={!!errors.phone}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="phone-input">Téléphone</InputLabel>
              <Input
                id="phone-input"
                type="number"
                value={phone}
                onChange={this.handleChange('phone')}
              />
              <FormHelperText>
                {errors.phone ? errors.phone : null}
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/GeneralInformations/RightFormComponent/index.js